import type { AxiosError, AxiosResponse } from "axios";
import type {
  CustomerMembersResponse,
  GetCustomerMembersParams,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

/**
 * Get all members (resources + portal users) for a customer
 * @param params - Query parameters including customerId, search, pagination
 */
export const getCustomerMembers = async (
  params: GetCustomerMembersParams,
): Promise<CustomerMembersResponse> => {
  try {
    const {
      customerId,
      perPage,
      page,
      searchQuery,
      sortColumn,
      sortDirection,
      serviceType,
    } = params;

    const queryParams = new URLSearchParams();

    if (perPage !== undefined) queryParams.set("per_page", String(perPage));
    if (page !== undefined) queryParams.set("page", String(page));
    if (searchQuery) queryParams.set("searchQuery", searchQuery);
    if (sortColumn) queryParams.set("sortColumn", sortColumn);
    if (sortDirection) queryParams.set("sortDirection", sortDirection);
    if (serviceType) queryParams.set("serviceType", serviceType);

    const query = queryParams.toString();
    const url = `/v2/customers/${customerId}/members${query ? `?${query}` : ""}`;

    const response = await axiosClient.get(url);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw response;
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};
